export enum ParticipateType {
  /**
   * 委托方
   */
  ENTRUST = 0,

  /**
   * 参与方
   */
  PARTICIPANT = 1
}

export const ParticipateTypeTextMap = {
  [ParticipateType.ENTRUST]: '发起竞价',
  [ParticipateType.PARTICIPANT]: '参与竞价'
}
